// Add Quiz Finish event to GTM
$('.wpProQuiz_content').on('learndash-quiz-finished', function(e) {
    
    dataLayer = dataLayer || [];
    
    var $quiz = e.values.item;
    var quizMeta = $quiz.data('quizMeta');
    
    dataLayer.push({
        'event': 'quiz_submit',
        'quiz': {
            'id': quizMeta.quiz_post_id,
            'status': e.values.status,
            'percentage': e.values.results.comp.result
        }
    });
});